import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import { EAvatarTypes, TAvatarType, TAvatarStyles } from 'shared/types/card.interface';
import { getAvatarStyles } from 'utils/avatar-helpers';

interface IAvatarProps {
  type: TAvatarType;
  firstName: string;
  lastName: string;
  isFullCard?: boolean;
}

const avatarStyles: TAvatarStyles = {
  [EAvatarTypes.Header]: getAvatarStyles({ lg: 56, md: 46 }, { lg: 32, md: 22 }),
  [EAvatarTypes.Profile]: getAvatarStyles(
    { lg: 171, md: 150, sm: 100, xs: 100 },
    { lg: 96, md: 75, sm: 56, xs: 56 },
  ),
  [EAvatarTypes.SmallCard]: getAvatarStyles(
    { lg: 80, md: 60, sm: 60, xs: 60 },
    { lg: 32, md: 22, sm: 22, xs: 22 },
  ),
  [EAvatarTypes.FullCard]: getAvatarStyles(
    { lg: 120, md: 90, sm: 80, xs: 80 },
    { lg: 46, md: 35, sm: 30, xs: 30 },
  ),
  [EAvatarTypes.MobileMenu]: getAvatarStyles(27, 12),
  [EAvatarTypes.CardFeatures]: getAvatarStyles(
    { lg: 24, md: 20, sm: 20, xs: 20 },
    { lg: 10, md: 8, sm: 8, xs: 8 },
  ),
};

export const Avatar: React.FC<IAvatarProps> = ({ type, firstName, lastName, isFullCard }) => {
  const avatarText = useMemo(() => {
    if (firstName.length || lastName.length) {
      return `${firstName[0]?.toUpperCase() || ''}${lastName[0]?.toUpperCase() || ''}`;
    }
    return '?';
  }, [firstName, lastName]);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
      sx={{
        ...avatarStyles[type].stack,
        backgroundColor: isFullCard ? 'myGrey.grey333' : 'secondary.main',
      }}
    >
      <Typography
        variant="overline"
        color="primary.contrastText"
        sx={{
          ...avatarStyles[type].typography,
          letterSpacing: '0',
        }}
      >
        {avatarText}
      </Typography>
    </Stack>
  );
};
